'use strict';

var core = require('@capacitor/core');

exports.AppUpdateAvailability = void 0;
(function (AppUpdateAvailability) {
    AppUpdateAvailability[AppUpdateAvailability["UNKNOWN"] = 0] = "UNKNOWN";
    AppUpdateAvailability[AppUpdateAvailability["UPDATE_NOT_AVAILABLE"] = 1] = "UPDATE_NOT_AVAILABLE";
    AppUpdateAvailability[AppUpdateAvailability["UPDATE_AVAILABLE"] = 2] = "UPDATE_AVAILABLE";
    AppUpdateAvailability[AppUpdateAvailability["UPDATE_IN_PROGRESS"] = 3] = "UPDATE_IN_PROGRESS";
})(exports.AppUpdateAvailability || (exports.AppUpdateAvailability = {}));
exports.FlexibleUpdateInstallStatus = void 0;
(function (FlexibleUpdateInstallStatus) {
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["UNKNOWN"] = 0] = "UNKNOWN";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["PENDING"] = 1] = "PENDING";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["DOWNLOADING"] = 2] = "DOWNLOADING";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["INSTALLING"] = 3] = "INSTALLING";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["INSTALLED"] = 4] = "INSTALLED";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["FAILED"] = 5] = "FAILED";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["CANCELED"] = 6] = "CANCELED";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["DOWNLOADED"] = 11] = "DOWNLOADED";
})(exports.FlexibleUpdateInstallStatus || (exports.FlexibleUpdateInstallStatus = {}));
exports.AppUpdateResultCode = void 0;
(function (AppUpdateResultCode) {
    /**
     * The user has accepted the update.
     */
    AppUpdateResultCode[AppUpdateResultCode["OK"] = 0] = "OK";
    /**
     * The user has denied or cancelled the update.
     */
    AppUpdateResultCode[AppUpdateResultCode["CANCELED"] = 1] = "CANCELED";
    /**
     * Some other error prevented either the user from providing consent or the update to proceed.
     */
    AppUpdateResultCode[AppUpdateResultCode["FAILED"] = 2] = "FAILED";
    /**
     * No update available.
     */
    AppUpdateResultCode[AppUpdateResultCode["NOT_AVAILABLE"] = 3] = "NOT_AVAILABLE";
    /**
     * Update type not allowed.
     */
    AppUpdateResultCode[AppUpdateResultCode["NOT_ALLOWED"] = 4] = "NOT_ALLOWED";
    /**
     * App update info missing.
     * You must call `getAppUpdateInfo()` before requesting an update.
     */
    AppUpdateResultCode[AppUpdateResultCode["INFO_MISSING"] = 5] = "INFO_MISSING";
})(exports.AppUpdateResultCode || (exports.AppUpdateResultCode = {}));

const AppUpdate = core.registerPlugin('AppUpdate', {
    web: () => Promise.resolve().then(function () { return web; }).then(m => new m.AppUpdateWeb()),
});

class AppUpdateWeb extends core.WebPlugin {
    async getAppUpdateInfo() {
        throw new Error('Web platform is not supported.');
    }
    async openAppStore() {
        throw new Error('Web platform is not supported.');
    }
    async performImmediateUpdate() {
        throw new Error('Web platform is not supported.');
    }
    async startFlexibleUpdate() {
        throw new Error('Web platform is not supported.');
    }
    async completeFlexibleUpdate() {
        throw new Error('Web platform is not supported.');
    }
}

var web = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AppUpdateWeb: AppUpdateWeb
});

exports.AppUpdate = AppUpdate;
//# sourceMappingURL=plugin.cjs.js.map
